module.exports = ".bot-dialog {\n  min-width: 500px;\n  padding: 20px;\n}\n\n.row {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin: 0 -15px;\n}\n\n.col-md-6 {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 50%;\n          flex: 0 0 50%;\n  max-width: 50%;\n  padding: 0 15px;\n  margin-bottom: 15px;\n}\n\n.w-100 {\n  width: 100%;\n}\n\nmat-form-field {\n  width: 100%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/offramp-clients/add-offramp-client/add-offramp-client.component.css
// module id = ./src/app/offramp-clients/add-offramp-client/add-offramp-client.component.css
// module chunks = main